import type { Consent } from '@repo/domain';
import { isApplicationMode } from '@repo/env-variables';
import { createStore } from '@repo/zustand';

import type { ReservationConsentCheck } from '@shared/types';

interface State {
  check: ReservationConsentCheck | undefined;
  saveCheck: (ownerId: string | undefined, consents: Consent[]) => void;
  reset: () => void;
}

// Deliberately not persisted: a reload drops the check, so a consent version
// bumped on the backend is asked for again on the next app start at the latest.
export const useReservationConsentStore = createStore<State>({
  name: 'ReservationConsentStore',
  isDev: isApplicationMode('dev'),
})((set) => ({
  check: undefined,
  saveCheck: (ownerId: string | undefined, consents: Consent[]) =>
    set({
      check: {
        ownerId,
        checkedAtTimestamp: Date.now(),
        expectedConsents: consents.filter((consent) => consent.isExpected),
      },
    }),
  reset: () => set({ check: undefined }),
}));
